/* eslint-disable */
import _m0 from "protobufjs/minimal";
import {
  NightsenseRequestedState_Enum,
  nightsenseRequestedState_EnumFromJSON,
  nightsenseRequestedState_EnumToJSON,
} from "../../../../gen/nightsense_manager/nightsense_requested_state";

export const protobufPackage = "skills";

export interface NightsenseActionArgs {
  requestedState: NightsenseRequestedState_Enum;
}

export interface NightsenseActionResultData {
}

export interface NightsenseActionStateData {
}

function createBaseNightsenseActionArgs(): NightsenseActionArgs {
  return { requestedState: 0 };
}

export const NightsenseActionArgs = {
  encode(message: NightsenseActionArgs, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.requestedState !== 0) {
      writer.uint32(16).int32(message.requestedState);
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): NightsenseActionArgs {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseNightsenseActionArgs();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 2:
          if (tag !== 16) {
            break;
          }

          message.requestedState = reader.int32() as any;
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): NightsenseActionArgs {
    return {
      requestedState: isSet(object.requestedState) ? nightsenseRequestedState_EnumFromJSON(object.requestedState) : 0,
    };
  },

  toJSON(message: NightsenseActionArgs): unknown {
    const obj: any = {};
    if (message.requestedState !== 0) {
      obj.requestedState = nightsenseRequestedState_EnumToJSON(message.requestedState);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<NightsenseActionArgs>, I>>(base?: I): NightsenseActionArgs {
    return NightsenseActionArgs.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<NightsenseActionArgs>, I>>(object: I): NightsenseActionArgs {
    const message = createBaseNightsenseActionArgs();
    message.requestedState = object.requestedState ?? 0;
    return message;
  },
};

function createBaseNightsenseActionResultData(): NightsenseActionResultData {
  return {};
}

export const NightsenseActionResultData = {
  encode(_: NightsenseActionResultData, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): NightsenseActionResultData {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseNightsenseActionResultData();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(_: any): NightsenseActionResultData {
    return {};
  },

  toJSON(_: NightsenseActionResultData): unknown {
    const obj: any = {};
    return obj;
  },

  create<I extends Exact<DeepPartial<NightsenseActionResultData>, I>>(base?: I): NightsenseActionResultData {
    return NightsenseActionResultData.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<NightsenseActionResultData>, I>>(_: I): NightsenseActionResultData {
    const message = createBaseNightsenseActionResultData();
    return message;
  },
};

function createBaseNightsenseActionStateData(): NightsenseActionStateData {
  return {};
}

export const NightsenseActionStateData = {
  encode(_: NightsenseActionStateData, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): NightsenseActionStateData {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseNightsenseActionStateData();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(_: any): NightsenseActionStateData {
    return {};
  },

  toJSON(_: NightsenseActionStateData): unknown {
    const obj: any = {};
    return obj;
  },

  create<I extends Exact<DeepPartial<NightsenseActionStateData>, I>>(base?: I): NightsenseActionStateData {
    return NightsenseActionStateData.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<NightsenseActionStateData>, I>>(_: I): NightsenseActionStateData {
    const message = createBaseNightsenseActionStateData();
    return message;
  },
};

type Builtin = Date | Function | Uint8Array | string | number | boolean | undefined;

export type DeepPartial<T> = T extends Builtin ? T
  : T extends globalThis.Array<infer U> ? globalThis.Array<DeepPartial<U>>
  : T extends ReadonlyArray<infer U> ? ReadonlyArray<DeepPartial<U>>
  : T extends {} ? { [K in keyof T]?: DeepPartial<T[K]> }
  : Partial<T>;

type KeysOfUnion<T> = T extends T ? keyof T : never;
export type Exact<P, I extends P> = P extends Builtin ? P
  : P & { [K in keyof P]: Exact<P[K], I[K]> } & { [K in Exclude<keyof I, KeysOfUnion<P>>]: never };

function isSet(value: any): boolean {
  return value !== null && value !== undefined;
}
